/* eslint-disable react/prop-types */
import * as React from 'react';

import { Result } from 'antd';

import { cn } from 'utils';

const PrimitiveResult = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Result>) => (
  <Result
    className={cn(
      'flex h-full flex-col items-center justify-center rounded bg-white [&_.ant-result-icon]:mb-2 [&_.ant-result-image]:mt-[unset]',
      className,
    )}
    {...props}
  />
);

export { PrimitiveResult };
